// extracted by mini-css-extract-plugin
export default {"table-container":"ResponsiveTable_table-container__eLhkr","table":"ResponsiveTable_table__mNCsW"};